import React from 'react';
import { Link, LinkProps, matchPath } from 'react-router-dom';
import { routeDefinitions } from 'Routes';

/** Preloads a route with the given pathname by importing the components */
const preloadRoute = (pathname: string) => {
  const route = routeDefinitions.find((r) =>
    matchPath({ path: pathname }, r.path),
  );

  route?.element?.preload?.();
};

/** Special react router link that supports preloading lazy routes */
const RouteLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => (
    <Link
      ref={ref}
      {...props}
      onMouseEnter={() => preloadRoute(props.to as string)}
    />
  ),
);

export default RouteLink;
